module.exports = __webpack_public_path__ + "static/media/quiz-hint-3-es-1080p.ed4cfcd7.mp4";